const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "vm_admin_token";

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}
export function setToken(t) {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {}
}

async function req(path, { method = "GET", body, auth = false } = {}) {
  const headers = {};
  if (body) headers["Content-Type"] = "application/json";
  if (auth) {
    const t = getToken();
    if (t) headers["Authorization"] = `Bearer ${t}`;
  }
  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail = "Request failed";
    try {
      const j = await res.json();
      if (typeof j.detail === "string") detail = j.detail;
      else if (Array.isArray(j.detail)) detail = j.detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
    } catch {}
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export const api = {
  // Public
  listConditions: () => req("/conditions"),
  getCondition: (slug) => req(`/conditions/${slug}`),
  createAppointment: (payload) => req("/appointments", { method: "POST", body: payload }),

  // Auth
  login: async (email, password) => {
    const data = await req("/auth/login", { method: "POST", body: { email, password } });
    if (data.token) setToken(data.token);
    return data;
  },
  logout: async () => {
    setToken(null);
    try {
      await req("/auth/logout", { method: "POST", auth: true });
    } catch {}
  },
  me: () => req("/auth/me", { auth: true }),

  // Admin
  updateCondition: (slug, patch) =>
    req(`/admin/conditions/${slug}`, { method: "PUT", body: patch, auth: true }),
  addConditionImage: (slug, dataUrl, caption = "") =>
    req(`/admin/conditions/${slug}/images`, {
      method: "POST",
      body: { data_url: dataUrl, caption },
      auth: true,
    }),
  deleteConditionImage: (slug, imageId) =>
    req(`/admin/conditions/${slug}/images/${imageId}`, { method: "DELETE", auth: true }),
  listAppointments: () => req("/appointments", { auth: true }),
};
